export const IS_USER_LOGIN = 'USER';

export const FETCH_ALBUMS = 'fetch_albums/FETCH_ALBUMS';
export const FETCH_USER_INFO = 'fetch_user_info/FETCH_USER_INFO';

export const ADD_SONG_TO_QUEUE = 'add_song_to_queue/ADD_SONG_TO_QUEUE';
